/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faEdit,
  faPlusCircle,
  faInfoCircle,
  faPencil,
} from "@fortawesome/free-solid-svg-icons";
import { DatePicker } from "antd";
import dayjs from "dayjs";

import usePersonalInformation from "./usePersonalInformation";
import { nameExtractor } from "../../../../_helpers/nameExtractor";
import LocationBasic from "../../../../_uiComponents/LocationBasic";
import { TimezoneSearchInput } from "../../../../_uiComponents/Search/TimezoneSearchInput";

export default (props) => {
  const {
    userData,
    gender,
    editResumeClicked,
    currency,
    onImageUpload,
    onInputBlur,
    onResumeEditClick,
    onTimeZoneChange,
    onLocationChange,
  } = usePersonalInformation(props);
  const isTimeZoneDisabled =
    userData?.user_details?.timezone === "UTC" ||
    userData?.user_details?.timezone === "Etc/UTC";

  return (
    <div className="hiring-process-dashboard  hiring-manager-profile-wrapper create-job-wrapper">
      <div className="job-detail-wrapper mt-4 pr-lg-4">
        <Container>
          <Row>
            <div className=" col-md-8 bg-white border-radius-10 border p-4 mb-3">
              <h2 className="mb-2">Personal Information</h2>

              <div className="py-3 form-group mb-0">
                <Row>
                  <Col lg={6}>
                    <div className="form-group">
                      <p className="font-weight-medium">
                        <span className="text-danger">* </span>Full name
                      </p>
                      <input
                        className="form-control mw-100"
                        type="text"
                        placeholder="Enter Full Name"
                        name={"user_full_name"}
                        defaultValue={userData?.user_details?.full_name}
                        disabled={true}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group">
                      <p className="font-weight-medium">
                        <span className="text-danger">* </span>Headline/Title
                      </p>
                      <input
                        className="form-control mw-100"
                        type="text"
                        placeholder="Enter Full Name"
                        name={"headline"}
                        defaultValue={userData?.headline}
                        onBlur={onInputBlur}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group">
                      <p className="font-weight-medium">
                        <span className="text-danger">* </span>Date of Birth
                      </p>
                      <div>
                        <DatePicker
                          value={
                            userData.dob === null
                              ? dayjs("2023-03-06", "YYYY-MM-DD")
                              : dayjs(userData.dob, "YYYY-MM-DD")
                          }
                          format={"YYYY-MM-DD"}
                          onChange={(_, datefi) => {
                            onInputBlur({
                              target: { value: datefi, name: "dob" },
                            });
                          }}
                          className="form-control"
                          getPopupContainer={(trigger) => trigger.parentNode}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group">
                      <p className="font-weight-medium">
                        <span className="text-danger">* </span>Gender
                      </p>
                      <span className="select">
                        <select
                          className="form-control bg-transparent text-capitalize"
                          onChange={onInputBlur}
                          name={"gender"}
                        >
                          <option
                            disabled={true}
                            value=""
                            selected={userData?.gender === null}
                          >
                            Select Gender
                          </option>
                          {Array.isArray(gender) &&
                            gender.map((item) => (
                              <option
                                key={item.key}
                                selected={userData?.gender === item.value}
                                defaultValue={item.value}
                              >
                                {item.key}
                              </option>
                            ))}
                        </select>
                      </span>
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="form-group">
                      <p className="font-weight-medium">
                        <span className="text-danger">*</span> Image
                      </p>

                      <div className="custom-img-upload-input">
                        <div className="file-input-wrapper text-center">
                          <label
                            htmlFor="candidatePhotoUpdate"
                            className="file-input"
                          >
                            <img
                              src={
                                userData?.user_details &&
                                userData.user_details?.user_meta_info &&
                                userData.user_details.user_meta_info
                                  ?.profile_image
                                  ? userData?.user_details &&
                                    userData.user_details?.user_meta_info &&
                                    userData.user_details.user_meta_info
                                      ?.profile_image
                                  : "/assets/images/user.png"
                              }
                              alt="candidate image"
                              className="rounded-circle "
                            />
                            <input
                              className="d-none"
                              type="file"
                              name="profile_image"
                              accept="image/*"
                              onChange={onImageUpload}
                              id="candidatePhotoUpdate"
                            />
                            <span className="btn-remove-pic cursor-pointer  bg-grey-2 rounded-circle">
                              <FontAwesomeIcon icon={faPencil} />
                            </span>
                          </label>
                        </div>
                        <p className="text-center" onClick={onImageUpload}>
                          Replace file or Upload file
                        </p>
                      </div>
                      <p className="fs-smallest text-grey-4">
                        Maximum file size 3MB - acceptable file types .jpg,
                        .jpeg, .gif, .png.
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            <div className=" col-md-8 bg-white border-radius-10 border p-4 mb-3">
              <h2 className="mb-2">Location</h2>
              <div className="py-3 form-group mb-0">
                <Row>
                  <Col lg={8} className="mb-3">
                    <LocationBasic
                      onLocationChange={(name, value) =>
                        onLocationChange(name, value)
                      }
                      country={userData?.country_name}
                      state={userData?.state_name}
                      city={userData?.city_name}
                    />
                  </Col>
                  <Col lg={4}>
                    <div className="form-group">
                      <p className="font-weight-medium">
                        <span className="text-danger">* </span>Time Zone
                      </p>
                      {/* <TimezoneSearchInput
                        className="form-control"
                        placeholder="Search Timezone..."
                        onSearchSelect={(item) =>
                          onTimeZoneChange({
                            target: {
                              value: item,
                              name: "timezone",
                            },
                          })
                        }
                        isDisabled={!isTimeZoneDisabled}
                        clearSearch={false}
                        defaultTimezoneValue={
                          userData?.user_details?.timezone
                        }
                      /> */}
                      <div className="form-control">
                        {userData?.user_details?.timezone}
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>

            <div className="job-detail col-md-8 bg-white border-radius-10 border p-4 mb-3">
              <h2 className="mb-2">Contact Details</h2>

              <div className="py-3 form-group mb-0">
                <Row>
                  <Col lg={6}>
                    <div className="form-group">
                      <p className="font-weight-medium">
                        <span className="text-danger">* </span>Phone Number
                      </p>
                      <input
                        className="form-control mw-100"
                        type="tel"
                        placeholder="Enter Phone Number"
                        name={"phone_number"}
                        defaultValue={
                          userData?.user_details &&
                          userData.user_details?.user_meta_info &&
                          userData.user_details.user_meta_info?.phone
                        }
                        disabled={true}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group">
                      <p className="font-weight-medium">
                        <span className="text-danger">* </span>Email Address
                      </p>
                      <input
                        className="form-control mw-100"
                        type="email"
                        placeholder="Enter Email"
                        name={"user_email"}
                        defaultValue={userData?.user_details?.email}
                        disabled={true}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </div>

            <div className="col-md-8 bg-white border-radius-10 border p-4 mb-3">
              <h2 className="mb-2">Personal Links</h2>

              <div className="py-3 form-group mb-0">
                <Row>
                  <Col lg={6}>
                    <div className="form-group">
                      <p className="font-weight-medium">Website URL</p>
                      <input
                        className="form-control mw-100"
                        type="tel"
                        placeholder="Enter Website Url"
                        name={"candidate_website"}
                        defaultValue={userData?.candidate_website}
                        onBlur={onInputBlur}
                      />
                      <p className="text-grey-4 fs-smallest mt-2">
                        Your homepage, blog or company website
                      </p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group">
                      <p className="font-weight-medium">LinkedIn URL</p>
                      <input
                        className="form-control mw-100"
                        type="email"
                        placeholder="Enter LInkedIn Url"
                        name={"linkedin_url"}
                        defaultValue={userData?.linkedin_url}
                        onBlur={onInputBlur}
                      />
                    </div>
                  </Col>
                  <Col lg={10}>
                    <div className="form-group">
                      <p className="font-weight-medium">GitHub URL</p>
                      <input
                        className="form-control mw-100"
                        type="email"
                        placeholder="Enter Github Url"
                        name={"github_url"}
                        defaultValue={userData?.github_url}
                        onBlur={onInputBlur}
                      />
                    </div>
                  </Col>
                  <div className="col-lg-10">
                    <div className="py-1 form-group">
                      <p className="font-weight-medium">
                        Resume{" "}
                        <span
                          onClick={onResumeEditClick}
                          className="btn-remove-pic cursor-pointer  bg-grey-2 rounded-circle"
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </span>
                      </p>
                      <div className="py-1 form-group position-relative">
                        {editResumeClicked ? (
                          <input
                            className="form-control bg-transparent"
                            type="file"
                            name="resume"
                            accept=".pdf"
                            onChange={onImageUpload}
                          />
                        ) : userData?.user_details &&
                          userData.user_details?.user_meta_info &&
                          userData.user_details.user_meta_info?.resume !==
                            null ? (
                          <p className="form-control bg-transparent d-flex align-items-center">
                            {nameExtractor(
                              userData?.user_details &&
                                userData.user_details?.user_meta_info &&
                                userData.user_details.user_meta_info?.resume
                            )}
                          </p>
                        ) : (
                          <p className="form-control mw-100 mb-0 d-flex justify-content-center align-items-center">
                            <span>
                              <FontAwesomeIcon
                                icon={faInfoCircle}
                                className="mr-3"
                              />
                              <span>No resume Chosen</span>
                            </span>
                            <span
                              onClick={onResumeEditClick}
                              className="ml-3 bg-light p-1 px-3 cursor-pointer rounded"
                            >
                              <FontAwesomeIcon
                                className="mr-3"
                                icon={faPlusCircle}
                              />
                              Upload New
                            </span>
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </Row>
              </div>
            </div>
            <div className="col-md-8 bg-white border-radius-10 border p-4 mb-3">
              <h2 className="mb-2">Salary</h2>

              <div className="py-3 form-group mb-0">
                <Row>
                  <Col lg={4}>
                    <div className="form-group">
                      <p className="font-weight-medium">
                        <span className="text-danger">* </span>Currency
                      </p>
                      <span className="select">
                        <select
                          className="form-control bg-transparent text-capitalize"
                          onChange={onInputBlur}
                          name={"payment_currency"}
                        >
                          <option
                            disabled={true}
                            value=""
                            selected={userData?.payment_currency === null}
                          >
                            default (INR(₹))
                          </option>
                          {Array.isArray(currency) &&
                            currency.map((item) => (
                              <option
                                key={item.key}
                                selected={
                                  userData?.payment_currency === item.value
                                }
                                value={item.value}
                              >
                                {item.key}
                              </option>
                            ))}
                        </select>
                      </span>
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="form-group">
                      <p className="font-weight-medium">Current Salary</p>
                      <input
                        className="form-control mw-100"
                        type="tel"
                        placeholder="Enter Your Current Salary"
                        name={"current_salary"}
                        defaultValue={userData?.current_salary}
                        onBlur={onInputBlur}
                      />
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="form-group">
                      <p className="font-weight-medium">Expected Salary</p>
                      <input
                        className="form-control mw-100"
                        type="email"
                        placeholder="Enter Expected Salary"
                        name={"expected_salary"}
                        defaultValue={userData?.expected_salary}
                        onBlur={onInputBlur}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Row>
        </Container>
      </div>
    </div>
  );
};
